var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReturn = function SvgReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 117 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7D23A1",
    d: "m86.256 5.86.047-.999h-.047zm-85.632 0 10 5.774V.087zm0 31.988h85.632v-2H.624zm85.632 0c4.268 0 11.714-.423 18.128-2.556 6.368-2.117 12.153-6.093 12.153-13.415h-2c0 5.959-4.626 9.47-10.784 11.517-6.112 2.033-13.306 2.454-17.497 2.454zm30.281-15.971c0-7.33-6.089-11.475-12.563-13.8-6.546-2.35-13.983-3.04-17.67-3.216l-.096 1.998c3.618.173 10.822.85 17.09 3.1 6.34 2.277 11.239 5.965 11.239 11.918zM86.256 4.86H9.624v2h76.632z"
  })));
};
export default SvgReturn;